import "core-js/modules/es.array.push.js";
import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import { rqtPostUpdateEmail, rqtGetCustomerDetail } from '@/services/cms/customer';
import { mapGetters } from 'vuex';
export default {
  components: {
    PageNavBackLayoutCpt
  },
  data() {
    return {
      btnLoading: false,
      isShowBtn: true,
      validateCode: undefined,
      isDisabled: true,
      email: undefined,
      mobile: undefined,
      emailFlag: undefined,
      customerDetail: {},
      customerAddress: {
        pcc: '',
        street: ''
      }
    };
  },
  computed: {
    ...mapGetters('account', ['user'])
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.mobile = this.$route.query.mobile;
      this.emailFlag = this.$route.query.addFlag;
      rqtGetCustomerDetail({
        id: this.user.customerId
        // id:10204
      }).then(res => {
        const resData = res.data.data;
        this.email = resData.customerDetail.email;
      }).catch(() => {});
    },
    //获取验证码
    showInput() {
      this.isDisabled = false;
    },
    //提交修改信息
    onSubmit() {
      const reg = /^([a-zA-Z0-9]+[-_.]?)+@[a-zA-Z0-9]+\.[a-z]+$/;
      if (!reg.test(this.email)) {
        this.$message.error('邮箱格式有误，请重新填写');
        return;
      }
      let param = {
        id: this.user.customerId,
        email: this.email
      };
      this.btnLoading = true;
      let that = this;
      rqtPostUpdateEmail(param).then(() => {
        this.btnLoading = false;
        this.$message.success('修改成功');
        //跳转到个人资料页
        setTimeout(() => {
          that.$router.push('/wx/mine');
        }, 1500);
      }).catch(err => {
        console.error('修改邮箱失败', err);
      });
    }
  }
};